import Request from './request';


async function fetch(data) {
    return Request('get', "api/receipt/history", data);
}


export default {
    fetch,
    
};